import React, {Fragment} from 'react';
import {useTheme} from '@mui/material';
import type {Media} from 'services/media/types';
import {useLocalization} from 'localization';
import {useOpenMultipleMedia} from 'services/media';
import {Card, Spacer, ToolBar} from 'components';
import {useTextValue} from 'schema/preview/hooks';
import {FileCard} from './FileCard';
import {ManifestationPanelContainer} from './ManifestationPanelContainer';

type Props = {
  media: Media[];
  manifestationId: string;
  onClose: () => void;
  trykkunderlagReserved?: boolean;
};

export const FilesPanel: React.FC<Props> = ({
  media,
  manifestationId,
  onClose,
  trykkunderlagReserved,
}) => {
  const TextValue = useTextValue();
  const {t} = useLocalization();
  const {colors} = useTheme();

  const {previewAll} = useOpenMultipleMedia(media);

  const OpenAllComponent = (
    <ToolBar.ControlledIconTool
      icon="Preview"
      size="small"
      onClick={previewAll}
      isCalling={false}
    />
  );

  return (
    <ManifestationPanelContainer
      title={t('page.metadata.manifestation.tools.files')}
      icon={'Files'}
      onClose={onClose}
      extraButtons={[OpenAllComponent]}>
      {trykkunderlagReserved ? (
        <Card colorx={colors.offWhite}>
          <TextValue>{t('error.files.reserved')}</TextValue>
        </Card>
      ) : null}

      {Array.isArray(media) && media.length > 0 ? (
        media.map((f, idx, data) => (
          <Fragment key={f.id}>
            <FileCard file={f} manifestationId={manifestationId} />
            {idx + 1 < data.length ? <Spacer size={1} /> : null}
          </Fragment>
        ))
      ) : (
        <Card colorx={colors.offWhite}>
          <TextValue>{t('error.files.empty')}</TextValue>
        </Card>
      )}
    </ManifestationPanelContainer>
  );
};
